import styled, { css } from 'styled-components';

import { TournamentMode } from '@/helpers/tournaments';

import { device, hexToRGB } from '@/styles/helpers';
import { pulseShadow2 } from '@/styles/keyframes';

export interface ScCountdownTournamentProps {
  mode?: TournamentMode;
}

export const ScCountdownTournament = styled.div<ScCountdownTournamentProps>`
  ${({ mode }) =>
    mode
      ? css`
          position: absolute;
          z-index: 3;
          top: 16px;
          left: 0;
          height: 48px;
          padding: 8px 8px 8px 32px;
          background-color: ${({ theme }) =>
            mode === TournamentMode.FINISHED
              ? hexToRGB(theme.whiteColor, 0)
              : hexToRGB(theme.whiteColor, 0.32)};
          border-radius: 0px 8px 8px 0px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: flex-start;
          align-items: center;

          @media (${device.mobile}) {
            height: 64px;
            flex-direction: column;
            align-items: flex-start;
            left: 16px;
            top: 0;
            padding: 9px 8px 7px;
            border-radius: 0px 0px 8px 8px;
          }
          .label {
            position: relative;
            font-weight: 700;
            font-size: 20px;
            line-height: 1.5;
            letter-spacing: 0.03em;
            text-transform: uppercase;
            padding: 0 16px;
            border-radius: 16px;
            @media (${device.mobile}) {
              padding: 8px;
              font-size: 10px;
              line-height: 1;
            }
            ${({ theme }) => {
              switch (mode) {
                case TournamentMode.ACTIVE:
                  return css`
                    color: ${({ theme }) => theme.blackColor};
                    background-color: ${({ theme }) => theme.whiteColor};
                    padding-left: 32px;
                    @media (${device.mobile}) {
                      padding: 4px 8px 4px 20px;
                    }
                    &::before {
                      content: '';
                      position: absolute;
                      left: 16px;
                      top: 50%;
                      margin-top: -4px;
                      background-color: ${theme.secondaryColor};
                      width: 8px;
                      height: 8px;
                      border-radius: 50%;
                      animation: ${pulseShadow2(theme.secondaryColor)} 1.3s
                        ease-in-out infinite;
                      @media (${device.mobile}) {
                        left: 8px;
                      }
                    }
                  `;
                case TournamentMode.COMING_SOON:
                  return css`
                    color: ${({ theme }) => theme.whiteColor};
                    background-color: ${({ theme }) => theme.secondaryColor};
                    @media (${device.mobile}) {
                      padding: 4px 8px !important;
                    }
                  `;
                case TournamentMode.FINISHED:
                  return css`
                    color: ${({ theme }) => theme.blackColor};
                    background-color: ${({ theme }) =>
                      hexToRGB(theme.whiteColor, 0.32)};
                    @media (${device.mobile}) {
                      padding: 4px 8px !important;
                    }
                  `;
                default:
                  return null;
              }
            }}
          }
          .countdown {
            margin-left: 8px;
            color: ${({ theme }) => theme.whiteColor};
            letter-spacing: 0.03em;
            text-transform: uppercase;
            font-weight: 700;
            font-size: 24px;
            line-height: 1.25;
            min-width: 150px;
            @media (${device.mobile}) {
              margin-left: 0;
              font-size: 18px;
              line-height: 1;
              margin-top: 6px;
              min-width: 112px;
            }
            span {
              position: relative;
              display: inline-block;
              padding-bottom: 8px;
              @media (${device.mobile}) {
                padding-bottom: 10px;
              }
              &::before {
                position: absolute;
                display: block;
                content: attr(attr-label);
                font-size: 10px;
                line-height: 1.2;
                white-space: nowrap;
                left: 50%;
                transform: translateX(-50%);
                text-transform: lowercase;
                bottom: 0;
                font-weight: 400;
              }
            }
          }
        `
      : css`
          .timer {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
            line-height: 16px;

            span {
              font-size: 12px;
              font-weight: 400;
              letter-spacing: 0.36px;
            }

            .value {
              min-width: 24px;
              font-size: 16px;
              font-weight: 700;
              letter-spacing: 0.48px;
            }

            .text {
              font-size: 12px;
              line-height: 12px;
            }
          }
        `}
`;
